import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only kick to login once /auth/me has finished AND there is truly no
    // cached user. Any auth error other than an explicit 401 keeps the
    // cached user in place so the dashboard stays available offline / on
    // flaky PWA cold starts.
    if (!loading && !user) {
      navigate("/", { replace: true });
    }
  }, [loading, user, navigate]);

  // OPTIMISTIC RENDER: if we have a cached user from a previous session,
  // render the dashboard immediately. `/auth/me` continues to run in the
  // background and only clears the user on an explicit 401.
  if (user) return children;

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-[#1a3fd1]" />
      </div>
    );
  }
  return null;
};

export default ProtectedRoute;
